export default defineNuxtRouteMiddleware(async (to) => {
  // Only check admin routes
  if (!to.path.startsWith('/admin')) {
    return
  }

  // Pinia is not active during async middleware on the server — skip until client
  if (import.meta.server) {
    return
  }

  const authStore = resolveAuthStore()
  if (!authStore) {
    return
  }

  await authStore.checkAuth()

  if (!authStore.isAuthenticated) {
    return navigateTo('/auth/login')
  }

  if (!authStore.isAdmin) {
    return navigateTo('/dashboard')
  }
}) 